// AllImagesPage.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './AllImagesPage.css';
import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';

const AllImagesPage = () => {
  const [newsEvents, setNewsEvents] = useState([]);
  const [admissions, setAdmissions] = useState([]);
  const [updates, setUpdates] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [userImage, setUserImage] = useState('');
  const [comments, setComments] = useState({});
  const [likes, setLikes] = useState({});
  const [dislikes, setDislikes] = useState({});
  const [userId, setUserId] = useState('');

  useEffect(() => {
    fetchNewsEvents();
    fetchAdmissions();
    fetchUpdates();
    fetchAllComments();
  }, []);

  const fetchNewsEvents = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/news-events');
      setNewsEvents(response.data);
    } catch (error) {
      console.error('Failed to fetch news events:', error.message);
    }
  };

  const fetchAdmissions = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/admissions');
      setAdmissions(response.data);
    } catch (error) {
      console.error('Failed to fetch admissions:', error.message);
    }
  };

  const fetchUpdates = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/updates');
      setUpdates(response.data);
    } catch (error) {
      console.error('Failed to fetch updates:', error.message);
    }
  };

  const fetchAllComments = async () => {
    try {
      const response = await axios.get('http://121.52.154.120:3001/api/comments');
      if (response.status === 200) {
        const commentsData = response.data.reduce((acc, comment) => {
          const key = `${comment.post_id}_${comment.post_type}`;
          acc[key] = acc[key] || { list: [] };
          acc[key].list.push({
            username: comment.username,
            content: comment.content,
            userImage: comment.user_image,
          });
          return acc;
        }, {});
        setComments(commentsData);
      } else {
        console.error(`Failed to fetch comments. Status: ${response.status}`);
      }
    } catch (error) {
      console.error('Failed to fetch comments:', error.message);
    }
  };

  const formatDescription = (description) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    return description.replace(urlRegex, (url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">Read More</a>`);
  };

  const handleGoogleLoginSuccess = (credentialResponse) => {
    try {
        const userObject = jwtDecode(credentialResponse.credential);
        setIsLoggedIn(true);
        setUserName(userObject.name);
        setUserImage(userObject.picture);
        setUserId(userObject.sub); // Assuming 'sub' is the user ID in the Google response
        alert(`Welcome, ${userObject.name}!`);
    } catch (error) {
        console.error('Failed to decode Google credential:', error);
    }
};

  const handleGoogleLoginError = () => {
    console.error('Google Login Failed');
    alert('Google Login Failed. Try again.');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserName('');
    setUserImage('');
    alert('You have logged out.');
  };

  const handleCommentChange = (id, postType, value) => {
    const key = `${id}_${postType}`;
    setComments((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        newComment: value,
      },
    }));
  };

  const handleCommentSubmit = async (id, postType) => {
    const key = `${id}_${postType}`;
    const newCommentContent = comments[key]?.newComment;

    if (newCommentContent) {
        try {
            const newComment = {
                post_id: id,
                post_type: postType,
                user_id: userId, // Using the properly defined userId
                content: newCommentContent,
            };

            console.log('Submitting Comment:', newComment); // Debug log

            const response = await axios.post('http://121.52.154.120:3001/api/comments', newComment);

            if (response.status === 201) {
                console.log('Comment submitted successfully:', response.data); // Debug log
                const { username, user_image } = response.data.comment;

                setComments((prev) => ({
                    ...prev,
                    [key]: {
                        newComment: '',
                        list: [...(prev[key]?.list || []), {
                            username,
                            content: newCommentContent,
                            userImage: user_image,
                        }],
                    },
                }));
            } else {
                console.error(`Failed to submit comment. Status: ${response.status}`);
            }
        } catch (error) {
            console.error('Failed to submit comment:', error.message);
        }
    } else {
        console.warn('No new comment to submit.'); // Debug log
    }
};

const handleLike = async (id) => {
    try {
        const response = await axios.post(`http://121.52.154.120:3001/api/comments/${id}/like`);
        if (response.status === 200) {
            console.log('Comment liked successfully:', response.data); // Debug log
            setLikes((prev) => ({ ...prev, [id]: response.data.comment.likes }));
        } else {
            console.error(`Failed to like comment. Status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to like comment:', error.message);
    }
};

const handleDislike = async (id) => {
    try {
        const response = await axios.post(`http://121.52.154.120:3001/api/comments/${id}/dislike`);
        if (response.status === 200) {
            console.log('Comment disliked successfully:', response.data); // Debug log
            setDislikes((prev) => ({ ...prev, [id]: response.data.comment.dislikes }));
        } else {
            console.error(`Failed to dislike comment. Status: ${response.status}`);
        }
    } catch (error) {
        console.error('Failed to dislike comment:', error.message);
    }
};

const renderInteractiveSection = (id, postType) => {
    const key = `${id}_${postType}`;
    return (
        <div className="interactive-section">
            <div className="like-dislike">
                <button className="like-button" onClick={() => handleLike(id)}>
                    👍 {likes[id] || 0}
                </button>
                <button className="dislike-button" onClick={() => handleDislike(id)}>
                    👎 {dislikes[id] || 0}
                </button>
            </div>
            <div className="comments">
                {isLoggedIn && (
                    <textarea
                        className="comment-box"
                        value={comments[key]?.newComment || ''}
                        onChange={(e) => handleCommentChange(id, postType, e.target.value)}
                        placeholder="Add a comment..."
                    ></textarea>
                )}
                {isLoggedIn && (
                    <button
                        className="comment-submit-button"
                        onClick={() => handleCommentSubmit(id, postType)}
                    >
                        Submit
                    </button>
                )}
                <div className="comment-list">
                    {(comments[key]?.list || []).map((comment, index) => (
                        <div key={index} className="comment-item">
                            <img src={comment.userImage || '/default-avatar.png'} alt={comment.username} className="user-image" />
                            <strong>{comment.username}</strong>: {comment.content}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};


  return (
    <GoogleOAuthProvider clientId="429574431734-imlnpkhd4mlfokpslhrbvorbar14mp91.apps.googleusercontent.com">
      <div className="page-container container">
        <h1>All Sections with Images</h1>

        {!isLoggedIn && (
          <div className="login-section">
            <h2>Login to Add Comments</h2>
            <GoogleLogin
              onSuccess={handleGoogleLoginSuccess}
              onError={handleGoogleLoginError}
            />
          </div>
        )}
        {isLoggedIn && (
          <div className="welcome-section">
            <p>Welcome, {userName}!</p>
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}

        <section className="section">
          <h2 className="news-events-heading">News and Events</h2>
          <div className="facebook-style-container row">
            {newsEvents.map((event) => (
              <div key={event.id} className="facebook-style-item col-md-12 d-flex">
                <div className="content flex-grow-1">
                  <h3>{event.title}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formatDescription(event.description),
                    }}
                  ></p>
                  {renderInteractiveSection(event.id, 'NewsEvent')}
                </div>
                <img
                  src={event.imageUrl}
                  alt={event.title}
                  className="facebook-style-image flex-shrink-0"
                />
              </div>
            ))}
          </div>
        </section>

        <section className="section">
          <h2 className="news-events-heading">Research and Innovations</h2>
          <div className="facebook-style-container row">
            {admissions.map((item) => (
              <div key={item.id} className="facebook-style-item col-md-12 d-flex">
                <div className="content flex-grow-1">
                  <h3>{item.title}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formatDescription(item.description),
                    }}
                  ></p>
                  {renderInteractiveSection(item.id, 'Admissions')}
                </div>
                <img
                  src={`http://121.52.154.120:3001${item.imageUrl}`}
                  alt={item.title}
                  className="facebook-style-image flex-shrink-0"
                />
              </div>
            ))}
          </div>
        </section>

        <section className="section">
          <h2 className="news-events-heading">General Updates</h2>
          <div className="facebook-style-container row">
            {updates.map((update) => (
              <div key={update.id} className="facebook-style-item col-md-12 d-flex">
                <div className="content flex-grow-1">
                  <h3>{update.title}</h3>
                  <p
                    dangerouslySetInnerHTML={{
                      __html: formatDescription(update.description),
                    }}
                  ></p>
                  {renderInteractiveSection(update.id, 'Updates')}
                </div>
                <img
                  src={`http://121.52.154.120:3001${update.imageUrl}`}
                  alt={update.title}
                  className="facebook-style-image flex-shrink-0"
                />
              </div>
            ))}
          </div>
        </section>
      </div>
    </GoogleOAuthProvider>
  );
};

export default AllImagesPage;
